import { useEffect } from 'react';
import { getUTMParams } from '../utils/utm';
import { logEvent } from 'firebase/analytics';
import { firebaseAnalytics } from '../storage/firebase';

export const useUtmRecording = () => {
	useEffect(() => {
		const utmParams = getUTMParams();
		if (utmParams !== null) {
			console.log('UTM Params: ', utmParams);
			logEvent(firebaseAnalytics, 'utm_params', utmParams);

			if (utmParams.utm_source !== null) {
				const utmSource = utmParams.utm_source.toLowerCase();
				console.log('UTM Source: ', utmSource);
				if (utmSource === 'youtube') logEvent(firebaseAnalytics, 'utm_source_youtube');
				else if (utmSource === 'instagram') logEvent(firebaseAnalytics, 'utm_source_instagram');
				else if (utmSource === 'twitter') logEvent(firebaseAnalytics, 'utm_source_twitter');
				else if (utmSource === 'kakao') logEvent(firebaseAnalytics, 'utm_source_kakao');
			}
		}
	}, []);
};
